// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__8ivpF","head":"ProcedureTableInfo_head__2QgYB"};